import React from "react";
import { MapPin } from "react-feather";
import { useBranchFilter } from "../../features/branchFilter/useBranchFilter";

// Header branch-picker (handoff §13.1): narrows every branch-scoped list
// screen (Customers, Products, Employees, Users) to one branch at a time via
// &branchId=. A branch-scoped (non all-branch) user only ever sees their own
// branch(es) here - no "All branches" option, so the picker is effectively
// just a label for them (the server would reject any other branchId anyway).
const BranchPicker = () => {
  const { selectedBranchId, setSelectedBranchId, availableBranches, showAllOption } =
    useBranchFilter();

  if (availableBranches.length === 0) return null;
  if (!showAllOption && availableBranches.length === 1) {
    return (
      <div className="d-none d-md-flex align-items-center text-muted me-3">
        <MapPin size={16} className="me-1" />
        <span>{availableBranches[0].branchCode}</span>
      </div>
    );
  }

  return (
    <div className="d-none d-md-flex align-items-center me-3">
      <MapPin size={16} className="me-1 text-muted" />
      <select
        className="form-control form-control-sm"
        style={{ width: "auto" }}
        value={selectedBranchId ?? ""}
        onChange={(e) => setSelectedBranchId(e.target.value ? Number(e.target.value) : null)}
      >
        {showAllOption && <option value="">All branches</option>}
        {availableBranches.map((b) => (
          <option key={b.branchId} value={b.branchId}>
            {b.branchCode}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BranchPicker;
